import './instrument';
import { registerIndexedDbConnectionRecovery } from './lib/indexedDbRecovery';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { ThemeProvider } from '@/components/theme-provider';
import './index.css';
import { getVersion } from './lib/version';

registerIndexedDbConnectionRecovery();

// Log version information on app start
getVersion().then((versionInfo) => {
  console.log(
    `%cDining Steward v${versionInfo.version}`,
    'color: #1E3A5F; font-size: 14px; font-weight: bold; padding: 4px 8px; background: #E3F2FD; border-radius: 4px;'
  );
  console.log(`Build Number: ${versionInfo.buildNumber}`);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider attribute="class" defaultTheme="light" disableTransitionOnChange>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

